import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ApiService } from '@services/api.service';
import { ProvidersComponent } from '@private/providers/providers.component';

@Component({
  selector: 'ew-providers-list',
  templateUrl: './providers-list.component.html',
  styleUrls: ['./providers-list.component.scss'],
})
export class ProvidersListComponent implements OnChanges {
  providers: any[] = [];
  provider: any;

  @Input() label: string = '';
  @Input() value!: string;
  @Input() disabled: boolean = false;
  @Input() width: string = '480px';
  @Input() currency: string | null = null;

  @Output() valueChanged = new EventEmitter<any>();

  get DEFAULT_LOGO() {
    return ProvidersComponent.DEFAULT_LOGO;
  }

  constructor(private API: ApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['currency'].currentValue &&
      changes['currency'].currentValue !== ''
    ) {
      this.API.get(
        'v1/bank-accounts?type=custom_provider,verified_provider&status=verified',
      ).subscribe((response: any) => {
        this.providers = response.records.filter(
          (bankAccount: any) =>
            bankAccount.currency.toLowerCase() == this.currency?.toLowerCase(),
        );
      });
    }
  }
}
